import { useEffect, useState } from "react";
import { IAdjustmentTablesSearchParam } from "../../../Interfaces/deltaHedgeAdjustment";
import { getGroups } from "../../../Requests/optionDomain";
import SelectableButtons from "../../../Components/Dropdown/SelectableButtons";
import { DropdownItem } from "../../../Interfaces/dropdownInterfaces";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import DeltaGammaRefTable from "../../../Tables/OptionDomain/Adjustment/DeltaGammaRefTable";

// interface IProps {
//   searchParams: IAdjustmentTablesSearchParam;
// }

const AdjustmentTablesWrapper = () => {
  const [searchParams, setSearchParam] = useState(
    {} as IAdjustmentTablesSearchParam
  );
  const [groups, setGroups] = useState([] as DropdownItem[]);

  useEffect(() => {
    getGroups()
      .then((resp) => {
        setGroups(resp);
        setSearchParam({ groupId: resp[0].id });
      })
      .catch(packetErrorHandler);
  }, []);

  const changeHandler = (name: string, value: any) => {
    setSearchParam({ ...searchParams, [name]: value });
  };

  return (
    <div className="flex flex-col justify-start items-start gap-3 w-full">
      <SelectableButtons
        label="گروه"
        name="groupId"
        options={groups}
        onChange={changeHandler}
        value={searchParams.groupId?.toString()}
        hideSelectAll
      />
      <DeltaGammaRefTable searchParams={searchParams} />
    </div>
  );
};

export default AdjustmentTablesWrapper;
